
export default class DrawableMarker {

	constructor(map, drawingFunc, position, args) {
		if (typeof document === 'undefined' || !position) {
			return;
		}

		// transparent 1x1 gif
		let icon = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
		if (typeof drawingFunc === 'function') {
			icon = drawingFunc();
		}

		const o = {
			map:      map,
			position: position,
			icon:     icon
		};

		if (args) {
			for (const prop in args) {
				if (Object.prototype.hasOwnProperty.call(args, prop)) {
					o[prop] = args[prop];
				}
			}
		}

		this.marker = new google.maps.Marker(o);
		this.marker.addListener('click', (event) => {
			if (typeof this.onClick === 'function') {
				this.onClick.call(this, event);
			}
		});
	}

	changeMap(map) {
		if (this.marker) {
			this.marker.setMap(map);
		}
	}

	remove() {
		if (this.marker) {
			this.marker.setMap(null);
		}
	}

}
